/* eslint-disable prefer-destructuring */
import {
	Autocomplete,
	FormControl,
	Icon,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import lod_ from "lodash";
import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import MDTypography from "components/Basics/MDTypography";
import WhitelistItemV2 from "./Whitelist/WhitelistItemV2";

const WhiteListItem = ({
	label,
	disabled,
	value,
	onChange,
	item,
	listOfApis,
	error,
	InputProps,
	...rest
}) => {
	const assistantIDs = useSelector(state => selectCurrentProfile(state).assistantID);
	const { user } = useSelector(state => state);

	const [valueAuto, setValueAuto] = useState(value);
	const [optionAuto, setOptionAuto] = useState([]);

	let whitelist = item.whitelist || [];
	let whitelistDynamic = item.whitelistDynamic || {};
	const whitelistDynamicVersion = whitelistDynamic?.version || "1.0";
	let type = item.type;

	const [showPassword, setShowPassword] = useState(false);

	const toggleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	async function loadSuggestions(
		searchText,
		collection,
		searchFields,
		apiName,
		action,
		limit = 10
	) {
		let querryData = [];
		searchFields.forEach(field => {
			const query = {};
			query[field] = { $regex: searchText };
			querryData.push(query);
		});

		let attribute = whitelistDynamic?.params?.attribute;

		querryData.push({ [attribute]: { $regex: searchText } });

		let dataQuerry = JSON.stringify({
			query: {
				$or: querryData
			}
		});

		let APIFind;
		let actionFind;
		if (apiName && action) {
			APIFind = listOfApis.find(item => item.name === apiName) || {};
			actionFind = APIFind.config.action[action];
		} else {
			return [];
		}

		let account = actionFind?.account ?? false;

		collection = collection || actionFind?.collection;

		// Merge collections is an array of collections name, that will be requested in the same time
		// The result will be merged in the same array
		const mergeCollections = actionFind?.mergeCollections || [];

		let config = {
			method: actionFind?.method ?? "GET",
			maxBodyLength: Infinity,
			url: `${APIFind.config.host}/api/v1/ressource/${collection}/items?search=${searchText}&page=1&limit=${limit}&account=${account}`,
			headers: {
				Authorization: `Bearer ${user.token}`,
				assistantID: assistantIDs,
				"Content-Type": "application/json"
			}
		};

		if (config.method === "GET") {
			config.data = dataQuerry;
		} else {
			config.data = {
				filter: actionFind?.filter,
				searchFields,
				mergeCollections,
				attribute,
				query: {
					$or: querryData
				}
			};
		}

		let result;
		await axios
			.request(config)
			.then(response => {
				result = response.data;
			})
			.catch(error => {
				// console.log(error);
			});

		return result?.results || [];
	}

	const ValueChange = async valueC => {
		setValueAuto(valueC);

		let result = await loadSuggestions(
			valueC,
			whitelistDynamic.params.collection,
			whitelistDynamic.params.searchFields,
			whitelistDynamic.apiName,
			whitelistDynamic.action
		);

		setOptionAuto(result);
	};

	const getOptionLabel = option => {
		let labelAttribute = option[whitelistDynamic?.params?.attribute] || "";
		let label = whitelistDynamic.params.searchFields.map(key => option[key]).join(" - ");
		label = labelAttribute + " - " + label;
		return label;
	};

	const onChangeDynamic = (event, newValue, option) => {
		if (option === "selectOption") {
			setValueAuto(newValue[whitelistDynamic.params.attribute]);
			onChange(newValue[whitelistDynamic.params.attribute]);
		} else if (option === "clear") {
			setValueAuto("");
			onChange("");
		}
	};

	if (lod_.isArray(whitelist) && !lod_.isEmpty(whitelist)) {
		return (
			<FormControl fullWidth>
				<InputLabel id="select-label">{label}</InputLabel>
				<Select
					labelId="select-label"
					id="select"
					disabled={disabled}
					label={label}
					value={value || null}
					onChange={e => {
						onChange(e.target.value);
					}}
				>
					{whitelist.map((option, index) => (
						<MenuItem key={index} value={option}>
							{option}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		);
	} else if (whitelistDynamic && !lod_.isEmpty(whitelistDynamic)) {
		switch (whitelistDynamicVersion) {
			case "2.0": {
				return (
					<WhitelistItemV2
						label={label}
						disabled={disabled}
						value={value}
						onChange={onChange}
						item={item}
						listOfApis={listOfApis}
						error={error}
						InputProps={InputProps}
						{...rest}
					/>
				);
			}
			default: {
				return (
					<Autocomplete
						id="auto"
						freeSolo
						disabled={disabled}
						options={optionAuto}
						onChange={onChangeDynamic}
						getOptionLabel={getOptionLabel}
						inputValue={valueAuto || ""}
						renderInput={params => (
							<MDInput {...params} label={label} onChange={e => ValueChange(e.target.value)} />
						)}
					/>
				);
			}
		}
	} else {
		const password = item.type === "string" && (item?.personalInformation ?? false);

		const getInputType = () => {
			if (password) {
				if (showPassword) {
					return "text";
				} else {
					return "password";
				}
			} else {
				return type;
			}
		};

		return (
			<>
				<MDInput
					disabled={disabled}
					type={getInputType()}
					className="dialogInput"
					label={label}
					value={value}
					onChange={e => {
						if (type === "number") {
							onChange(parseFloat(e.target.value));
						} else {
							onChange(e.target.value);
						}
					}}
					InputProps={{
						endAdornment: password ? (
							<InputAdornment
								position="end"
								style={{
									pointerEvents: "auto"
								}}
							>
								{error && (
									<Icon fontSize="medium" color="error">
										info
									</Icon>
								)}
								<IconButton color="info" onClick={toggleShowPassword}>
									<Icon fontSize="medium" color="info">
										{showPassword ? "visibility_off" : "visibility"}
									</Icon>
								</IconButton>
							</InputAdornment>
						) : null
					}}
					{...InputProps}
					{...rest}
				/>
				<MDTypography
					variant="caption"
					color="error"
					style={{
						display: error ? "block" : "none"
					}}
				>
					Cette valeur doit être unique
				</MDTypography>
			</>
		);
	}
};
export default WhiteListItem;
